import React, { useState, useEffect } from "react";
import JImage from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import UploadLogoModal from "../../UploadLogoModal/UploadLogoModal.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import queryString from "query-string";
import { useUser } from "contexts/userContext/userContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";
import { useLocation } from "react-router-dom";
import { jumbomailImagesSizeLimit } from "utils/jumbomailSettings.js";

const fileReader = new FileReader();

const LogoUpload = () => {
  const { setModal } = useModal();
  const { getTextByKey } = useContent();
  const { getUserData, getUserProfileImage } = useUser();
  const { addToast } = useToasts();
  const [hover, setHover] = useState(null);
  const location = useLocation();
  const searchParams = queryString.parse(location.search);
  const setProfileAsBusinessLogo = searchParams.set_profile;
  const [error, setError] = useState(null);
  const userData = getUserData();
  const [imageLogoName, setImageLogoName] = useState("");
  const [userBusinessLogo, setUserBusinessLogo] = useState(
    userData.UserBussinessLogo
  );

  const disabledEditingByTopUser = getUserData().TopUserBrandingEnabled;

  const handleChange = (e) => {
    //
    setError(null);
    const allowedExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();
    const fileSize = e.target.files[0].size;
    const validSize = jumbomailImagesSizeLimit["businessLogo"];

    const allowedSize = validSize >= fileSize;
    const isAllowedExtension = allowedExtensions.includes(fileExtension);
    if (isAllowedExtension && allowedSize) {
      setError(null);
    } else {
      setError(
        !isAllowedExtension
          ? getTextByKey("file-type-not-supported")
          : getTextByKey("embed-logo-validation-size-text")
      );
      if (!isAllowedExtension) {
        addToast(getTextByKey("file-type-not-supported"), {
          appearance: "error",
        });
      }
    }

    if (e.target.files[0]) {
      fileReader.readAsDataURL(e.target.files[0]);
      const logoName = e.target.files[0].name.replaceAll("&", "-");
      setImageLogoName(logoName);
    }
  };

  const removeImageApi = () => {
    removeBusinessLogo();
  };

  const removeBusinessLogo = async () => {
    const response = await apiRequest(
      "UserTemplates",
      "DeleteBusinessLogoReact"
    );
    if (response.status === "success") {
      setUserBusinessLogo(null);
      addToast(getTextByKey("remove-business-logo-success"), {
        appearance: "success",
      });
    }
  };

  fileReader.onload = function (event) {
    var image = new Image();
    image.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      //const ratio = 1;
      const ratio =
        image.width > 799 ? 1 : image.width > 400 ? image.width / 250 : 1;
      canvas.width = image.width / ratio;
      canvas.height = image.height / ratio;
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      setModal(() => (
        <UploadLogoModal
          errorFile={error}
          setError={setError}
          pcImage={true}
          LogoName={imageLogoName}
          logoImage={canvas.toDataURL()}
          setLogoImage={setUserBusinessLogo}
          removeImageApi={removeImageApi}
        />
      ));
    };
    image.src = event.target.result;
  };

  useEffect(() => {
    if (setProfileAsBusinessLogo === "true") {
      let profileImageName = getUserProfileImage()
        .split("profileresize/")[1]
        .split("?")[0];
      setModal(() => (
        <UploadLogoModal
          errorFile={error}
          setError={setError}
          pcImage={false}
          LogoName={profileImageName}
          logoImage={getUserProfileImage()}
          setLogoImage={setUserBusinessLogo}
          removeImageApi={removeImageApi}
        />
      ));
    }
  }, []);

  const openModal = () => {
    if (userBusinessLogo) {
      setModal(() => (
        <UploadLogoModal
          errorFile={error}
          setError={setError}
          pcImage={true}
          LogoName={imageLogoName}
          logoImage={userBusinessLogo}
          setLogoImage={setUserBusinessLogo}
          removeImageApi={removeImageApi}
        />
      ));
    }
  };

  return (
    <div
      className={`cover-and-logo-upload-logo`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="logo-image">
        {userBusinessLogo && <JImage src={userBusinessLogo} alt="" title="" />}
      </div>
      {!disabledEditingByTopUser && (
        <div
          className={`hover-div ${
            userBusinessLogo ? "hover-logo" : "not-hover-logo"
          }`}
          onClick={openModal}
        >
          {!userBusinessLogo && (
            <input
              accept="image/*"
              className="input-image-class"
              name="newImage"
              type="file"
              title=""
              onChange={(e) => handleChange(e)}
            />
          )}
          <div className="upload-file-text">
            <Icon name="cloud-upload" white></Icon>
            <span>{getTextByKey("profile-upload-image-button")}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoUpload;
